export const classes = {
  wrapper: 'flex flex-col h-full min-h-0',
  viewer: 'relative grow flex justify-start w-full min-h-0',
};
